(() => {
  const FALLBACK_VENDOR = "renard's melt bistro";
  /** Same copy as `cart.bistro_mixed_warning` in locales (used when theme cart snippet is not on the page). */
  const MIXED_WARNING_TEXT =
    'Melt Bistro items are prepared fresh to order! Bistro and Retail items must be ordered separately. Retail store pickups must be scheduled by noon the day before pickup.';

  let lastMixed = false;

  function normalizeVendor(v) {
    return String(v || '')
      .trim()
      .toLowerCase()
      .replace(/[\u2018\u2019\u0060\u00B4]/g, "'");
  }

  function bistroVendorCanonical() {
    const el = document.querySelector('[data-bistro-mixed-cart-warning]');
    const fromDom = el?.dataset?.bistroVendor;
    return fromDom ? normalizeVendor(fromDom) : FALLBACK_VENDOR;
  }

  function isBistroLine(item, canonical) {
    return normalizeVendor(item.vendor) === canonical;
  }

  /** POS Cafe Online — "Proceed to Checkout" (scoped to .poscafe-app when present). */
  function getPosCafeCheckoutButtons() {
    const matches = [];
    const tryBtn = (btn) => {
      if (/proceed\s+to\s+checkout/i.test(btn.textContent)) matches.push(btn);
    };
    const roots = document.querySelectorAll('.poscafe-app');
    if (roots.length) {
      roots.forEach((root) => root.querySelectorAll('button').forEach(tryBtn));
    } else {
      document.querySelectorAll('button').forEach(tryBtn);
    }
    document.querySelectorAll('.pc-cart-modal').forEach((modal) => {
      getPosCafeModalCheckoutButtons(modal).forEach((btn) => {
        if (!matches.includes(btn)) matches.push(btn);
      });
    });
    return matches;
  }

  /** POS Cafe Online ordering cart modal (may mount outside `.poscafe-app`). */
  function getPosCafeModalCheckoutButtons(modal) {
    return Array.from(modal.querySelectorAll('button')).filter((btn) =>
      /checkout/i.test(btn.textContent)
    );
  }

  /** Mixed warning inside each `.pc-cart-modal`, placed just above its checkout button. */
  function updatePosCafeModalWarnings(show, text) {
    document.querySelectorAll('.pc-cart-modal').forEach((modal) => {
      let warn = modal.querySelector('.cart-bistro-mixed-warning--pc-modal');
      if (!show) {
        if (warn) warn.remove();
        return;
      }
      const btn = getPosCafeModalCheckoutButtons(modal)[0];
      if (!btn) return;
      if (!warn) {
        warn = document.createElement('div');
        warn.className = 'alert alert--note text-size--small cart-bistro-mixed-warning cart-bistro-mixed-warning--pc-modal';
        warn.setAttribute('role', 'status');
      }
      if (warn.textContent !== text) warn.textContent = text;
      // Only move when needed so the modal observer doesn't loop
      if (warn.nextElementSibling !== btn) btn.before(warn);
    });
  }

  /** Cart terms checkbox (theme: #AgreeToTos) — when present, checkout stays disabled until checked. */
  function termsBlockCheckout() {
    const box = document.getElementById('AgreeToTos');
    return box ? !box.checked : false;
  }

  function applyCheckoutBlock(isMixed) {
    const disable = isMixed || termsBlockCheckout();
    const warnText = isMixed
      ? Array.from(document.querySelectorAll('[data-bistro-mixed-cart-warning]'))
          .find((el) => !el.classList.contains('hidden'))
          ?.textContent?.trim() ||
        document.getElementById('cart-bistro-mixed-warning-fallback')?.textContent?.trim() ||
        MIXED_WARNING_TEXT
      : '';

    document.querySelectorAll('button[name="checkout"]').forEach((btn) => {
      btn.disabled = disable;
      if (isMixed && warnText) btn.setAttribute('title', warnText);
      else btn.removeAttribute('title');
    });

    getPosCafeCheckoutButtons().forEach((btn) => {
      // Guarded so the `disabled` attribute observer on .pc-cart-modal doesn't loop
      if (btn.disabled !== disable) btn.disabled = disable;
      btn.setAttribute('aria-disabled', disable ? 'true' : 'false');
      btn.classList.toggle('bistro-mixed-checkout--disabled', disable);
      if (isMixed && warnText) btn.setAttribute('title', warnText);
      else btn.removeAttribute('title');
    });

    updatePosCafeModalWarnings(isMixed, warnText);

    document.body.classList.toggle('bistro-mixed-checkout-blocked', isMixed);
  }

  function syncCheckoutFromLastMixed() {
    applyCheckoutBlock(lastMixed);
  }

  function updateMixedWarnings(show) {
    const themeEls = document.querySelectorAll('[data-bistro-mixed-cart-warning]');

    if (themeEls.length > 0) {
      themeEls.forEach((el) => {
        el.classList.toggle('hidden', !show);
        el.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      const fb = document.getElementById('cart-bistro-mixed-warning-fallback');
      if (fb) fb.remove();
    } else {
      let fb = document.getElementById('cart-bistro-mixed-warning-fallback');
      if (show) {
        if (!fb) {
          fb = document.createElement('div');
          fb.id = 'cart-bistro-mixed-warning-fallback';
          fb.className =
            'alert alert--note text-size--small cart-bistro-mixed-warning cart-bistro-mixed-warning--fallback';
          fb.setAttribute('role', 'status');
          fb.textContent = MIXED_WARNING_TEXT;
          document.body.appendChild(fb);
        }
        fb.classList.remove('hidden');
        fb.setAttribute('aria-hidden', 'false');
      } else if (fb) {
        fb.classList.add('hidden');
        fb.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function getVisibleMixedWarningEl() {
    const themeEl = Array.from(document.querySelectorAll('[data-bistro-mixed-cart-warning]')).find(
      (el) => !el.classList.contains('hidden')
    );
    if (themeEl) return themeEl;

    const fb = document.getElementById('cart-bistro-mixed-warning-fallback');
    if (fb && !fb.classList.contains('hidden')) return fb;

    return null;
  }

  function isCartContextVisible() {
    const onCartPage = document.body.classList.contains('template-cart');
    const onBistroOrderAhead = document.body.classList.contains('template-page-bistro-order-ahead');
    const drawer = document.getElementById('site-cart-sidebar');
    const drawerOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
    return onCartPage || onBistroOrderAhead || drawerOpen;
  }

  function getStickyHeaderOffsetPx() {
    const header =
      document.querySelector('.sticky-header') ||
      document.querySelector('[data-js-sticky-header]') ||
      document.querySelector('header');
    if (!header) return 0;

    const style = window.getComputedStyle(header);
    const isStickyLike = style.position === 'sticky' || style.position === 'fixed';
    if (!isStickyLike) return 0;
    if (style.display === 'none' || style.visibility === 'hidden') return 0;

    const rect = header.getBoundingClientRect();
    // Only count it if it is actually pinned at the top.
    if (rect.height <= 0) return 0;
    if (rect.bottom <= 0) return 0;
    if (rect.top > 1) return 0;

    return Math.ceil(rect.height);
  }

  function scrollMixedWarningIntoView() {
    if (!isCartContextVisible()) return false;
    const el = getVisibleMixedWarningEl();
    if (!el) return false;
    // Allow DOM/class changes to settle before scrolling.
    setTimeout(() => {
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        // Ignore if browser doesn't support options signature.
        el.scrollIntoView(true);
      }

      // If we're scrolling the window, offset for sticky headers so the warning
      // isn't hidden under the site header.
      const drawer = document.getElementById('site-cart-sidebar');
      const drawerOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
      if (!drawerOpen) {
        const applyOffset = () => {
          const offset = getStickyHeaderOffsetPx();
          if (offset > 0) window.scrollBy({ top: -(offset + 12), left: 0, behavior: 'smooth' });
        };

        // Apply immediately, then re-apply shortly after in case the sticky
        // header only becomes visible/pinned after the scroll.
        applyOffset();
        setTimeout(applyOffset, 150);
        setTimeout(applyOffset, 350);
      }
    }, 0);
    return true;
  }

  function scrollMixedWarningWhenDrawerOpens() {
    const drawer = document.getElementById('site-cart-sidebar');
    if (!drawer) return;
    if (drawer.getAttribute('aria-hidden') === 'false') {
      scrollMixedWarningIntoView();
      return;
    }
    if (window.__bistroMixedScrollObserverAttached) return;
    window.__bistroMixedScrollObserverAttached = true;

    const obs = new MutationObserver(() => {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        obs.disconnect();
        window.__bistroMixedScrollObserverAttached = false;
        scrollMixedWarningIntoView();
      }
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'style'] });

    // Safety: disconnect after a short window to avoid lingering observers.
    setTimeout(() => {
      try { obs.disconnect(); } catch (e) {}
      window.__bistroMixedScrollObserverAttached = false;
    }, 6000);
  }

  function applyMixedState(cart) {
    const items = cart.items || [];
    const canonical = bistroVendorCanonical();
    let hasBistro = false;
    let hasOther = false;
    for (const item of items) {
      if (isBistroLine(item, canonical)) hasBistro = true;
      else hasOther = true;
    }
    const show = items.length > 0 && hasBistro && hasOther;
    const bistroOnly = items.length > 0 && hasBistro && !hasOther;
    const wasMixed = lastMixed;
    lastMixed = show;

    updateMixedWarnings(show);

    document.body.classList.toggle('cart-bistro-only', bistroOnly);

    applyCheckoutBlock(show);

    if (show && !wasMixed) {
      const scrolled = scrollMixedWarningIntoView();
      if (!scrolled) scrollMixedWarningWhenDrawerOpens();
    }
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then(applyMixedState)
      .catch(() => {});
  }

  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), ms);
    };
  }

  const reapplyPosCafeUi = debounce(() => applyCheckoutBlock(lastMixed), 120);

  /** Attach when `.poscafe-app` mounts (app may hydrate after first paint). */
  function tryAttachPosCafeObserver() {
    const root = document.querySelector('.poscafe-app');
    if (root && !root.dataset.bistroObserverAttached) {
      root.dataset.bistroObserverAttached = '1';
      new MutationObserver(reapplyPosCafeUi).observe(root, { childList: true, subtree: true });
    }

    /** Cart modal: also watch `disabled` in case the app re-enables its checkout button on re-render. */
    document.querySelectorAll('.pc-cart-modal').forEach((modal) => {
      if (modal.dataset.bistroObserverAttached) return;
      modal.dataset.bistroObserverAttached = '1';
      new MutationObserver(reapplyPosCafeUi).observe(modal, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
      reapplyPosCafeUi();
    });
  }

  const debouncedTryAttach = debounce(tryAttachPosCafeObserver, 80);

  function setupPosCafeRootWatch() {
    tryAttachPosCafeObserver();
    if (!window.__bistroPosCafeBodyObserver) {
      window.__bistroPosCafeBodyObserver = true;
      new MutationObserver(debouncedTryAttach).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (!window.__bistroMixedCartFetchPatched) {
    window.__bistroMixedCartFetchPatched = true;
    const origFetch = window.fetch.bind(window);
    window.fetch = function (...args) {
      const out = origFetch(...args);
      try {
        const u = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/i.test(u)) {
          out.finally(() => setTimeout(refresh, 0));
        }
      } catch (e) {
        /* ignore */
      }
      return out;
    };
  }

  document.addEventListener('DOMContentLoaded', () => {
    const tos = document.getElementById('AgreeToTos');
    if (tos) tos.addEventListener('change', syncCheckoutFromLastMixed);
    setupPosCafeRootWatch();
    refresh();
  });

  document.addEventListener('shopify:section:load', () => {
    tryAttachPosCafeObserver();
    refresh();
  });

  document.addEventListener('cart-updated', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('add-to-cart', refresh, true);
})();
